
import { Watch, Component, Vue, Ref, PropSync, Prop } from 'vue-property-decorator';

import { nursePresWayList } from "@/api/nurse";

@Component
export default class RelationPresTransferHome extends Vue {
   @Prop({ type: Array, default: () => [] }) stashList !: Array<any>;
   @Prop({ default: true }) clearStashListFlag !: boolean;
   @Ref("transferRef") transferRef: any;

   stashPresHome = [];
   presHome = [];

   mounted() {
       this.getPresHome();
   }
   getPresHome() {
        nursePresWayList({ pageNum: 1, pageSize: 1000, presType: 2 }).then((res) => {
           console.log("nursePresHomeList", res.data)
           res.data.list.forEach((item) => {
                item.presName = item.presName + `（${item.status == 1 ? "启用" : "禁用"}）`;
            });
           this.presHome = res.data.list;
       });
   };

   closeTransfer() {
       this.transferRef?.clearQuery("left");
       this.transferRef?.clearQuery("right");
       if (this.clearStashListFlag) this.clearStashList();
   };

   clearStashList() {
       this.stashPresHome = [];
   };

   getStashStoreInfoList() {
       return this.stashPresHome.map((item) => {
           const { id, storeName } = this.presHome.find((store) => store.id == item) || {};
           return {
               id,
               storeName
           };
       });
   };

   confirmTransfer() {
       this.$emit("syncPresHome", this.stashPresHome);
       this.$emit("syncStoreInfoList", this.getStashStoreInfoList());
       this.closeTransfer();
   };

   @Watch("stashPresHome")
    syncStashPresWay(list) {
        this.$emit("syncPresHome", [...list]);
    }

   @Watch("stashList")
   @Watch("presHome", { deep: true })
   handleStashList(list) {
       this.stashPresHome = [...this.stashList];
   }
}
